import { DOKBOT_KIT_URL, DOKBOT_KIT_ID, DOKBOT_TYPE_CUSTOM } from './constants';
import { dokbotTrackError, parseWorkflowId } from './helpers';
const SURVEY_LAUNCH_DELAY = 3000;
let launcher = null;
const isSupported = () => {
    return window.Dokbot?.meta.isBrowserSupported;
};
const initLauncher = (surveyId, isDokbotAvailable) => {
    if (!isSupported()) {
        dokbotTrackError(DOKBOT_TYPE_CUSTOM);
        return;
    }
    const { workflowId, orgSlug, orgId } = parseWorkflowId(surveyId);
    launcher = window.Dokbot.RuntimeComponent.overlay({
        workflowId: isDokbotAvailable ? workflowId : null,
        orgId: orgId,
        orgSlug: orgSlug,
        consultationId: '+',
        closeButton: true,
        closeOnExit: true,
        params: { surveyData: {} },
        errorKitOverride: {
            id: DOKBOT_KIT_ID,
            url: DOKBOT_KIT_URL,
        },
    }, {
        preload: true,
        overlayCloseable: false,
        explosionColor: '#0f1722',
    });
};
const launchSurvey = () => {
    if (!isSupported()) {
        return;
    }
    launcher();
};
const launchDelayedOneIn = (oneInNumber, customDelay) => {
    let shouldBeShown = false;
    if (oneInNumber <= 1) {
        launchSurvey();
        return;
    }
    shouldBeShown = Math.floor(Math.random() * oneInNumber) === 0;
    if (shouldBeShown) {
        setTimeout(() => launchSurvey(), customDelay !== undefined ? customDelay : SURVEY_LAUNCH_DELAY);
    }
};
export { launchSurvey, launchDelayedOneIn, initLauncher };
